/**
 * Accounts inventory API endpoint config.
 * AIM owns GET /account; BrightNav is a consumer (same slot as Financial Snapshot).
 */
export const ACCOUNTS_API_CONFIG = {
  /** Key into `environment.apiEndpoints`. */
  apiName: 'api-internal' as const,
  /** Path prefix for the inventory GET. */
  pathPrefix: '/account',
  /**
   * How the selected client guid is scoped on GET.
   * `'query'` → `/account?guid=…`
   */
  guidScope: 'query' as const,
} as const;

export type AccountsApiConfig = typeof ACCOUNTS_API_CONFIG;
